/**
 * Returns `true` if the document body has the provided `data-page` name.
 */
export default function isPage(pageName) {
  return document.body.getAttribute('data-page') === pageName;
}
